import * as React from "react";
// import { pure } from 'recompose';
import * as StyledComponent from "@tunnel-components/@sharded/@styled/styled";
import { isLessThan30Days /*,isLessThan7Days */ } from "@Cyclope-Utils/index";
import { Link } from "react-router-dom";
import * as Paths from "@tunnel-enums/index";
import * as cx from "classnames";
import Stream from "@tunnel-components/@sharded/widgets/stream/component";
import * as i18next from "i18next";
import * as Utils from "@Cyclope-Utils/index";
import * as Enums from "@tunnel-enums/index";
/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    arrayOfIncident,
    Elem,
    onActive,
    actionloading,
    onExtractImpact,
    onExtractVideo,
  } = props;
  /**
   * @description : retourne un objet ( utilisateur )
   * @const
   * @name User
   * @type { any  }
   */
  const User: any = Utils.createdUserRoles();
  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <StyledComponent.ModalContainer
      isVisible={Elem && isLessThan30Days(Elem) && arrayOfIncident}
      style={{ backgroundColor: "transparent" }}
    >
      <div style={{ height: "auto" }}>
        {/** box incident simulation */}
        <StyledComponent.BoxSnapshotContainer
          className="boxSnapshot"
          isVisible={!!Elem && arrayOfIncident && Elem.fake}
          style={{
            height: "auto",
            minHeight: "100px",
            width: "380px",
            top: "50%",
            left: "50%",
            transform: "translateY(-50%)",
          }}
        >
          <div className="vcart-incidents">
            <div className="cart-incident">
              <div className="image-snapshot-explore">
                <div className="close-box-snapshot" onClick={onActive}>
                  <span className="la-croix" />
                </div>
                <div className="fakeincident-explore">
                  <div className="fakeincident-in-explorer">
                    {i18next.t("simulation")}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </StyledComponent.BoxSnapshotContainer>
        {/** box incident */}
        <StyledComponent.BoxSnapshotContainer
          className="boxSnapshot"
          isVisible={arrayOfIncident && isLessThan30Days(Elem) && !Elem.fake}
          style={{
            height: "auto",
            minHeight: "100px",
            width: "380px",
            top: "50%",
            left: "50%",
            transform: "translateY(-50%)",
          }}
        >
          <div className="vcart-incidents">
            <div className="cart-incident">
              <div className="image-snapshot-explore">
                {actionloading && (
                  <div className="actionLoader">
                    <div className="lds-spinner">
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                    </div>
                  </div>
                )}

                <div className="close-box-snapshot" onClick={onActive}>
                  <span className="la-croix" />
                </div>

                {!!Elem && Elem.snapshot !== null && (
                  <Link
                    to={`${Paths.PathsNamesEnums.TUNNELWATCHINCIDENTFILE}${
                      !!Elem && Elem.id
                    }`}
                  >
                    <Stream
                      localUrl={!!Elem && Elem.snapshot}
                      name={
                        !!Elem && Elem.camera.section
                          ? Elem.camera.code
                          : undefined
                      }
                      classnames="imageStream"
                    />
                  </Link>
                )}
                {!!Elem && Elem.snapshot === null && (
                  <div
                    style={{
                      width: "100%",
                      height: "150px",
                      position: "relative",
                    }}
                  >
                    <div className="impossible">
                      <p
                        style={{
                          color: "white",
                          width: "100%",
                          position: "absolute",
                          top: "80%",
                          textAlign: "center",
                        }}
                      >
                        {i18next.t("impossible de charge l image")}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="bottomCartIncident animated slideInDown">
            {!!Elem && isLessThan30Days(Elem) && (
              <div className="extract-pdf-video">
                {Utils.simpleAuthorizationIsAllowed(User, [
                  Enums.AuthorizationRightsEnums.INCIDENTFILEEXPORTERPDF,
                ]) && (
                  <span
                    className={cx("pdfVideoIcon", {
                      "active-extract": actionloading,
                    })}
                    onClick={onExtractImpact}
                  >
                    {" "}
                    {i18next.t("extraire le pdf")}{" "}
                  </span>
                )}
                {Utils.simpleAuthorizationIsAllowed(User, [
                  Enums.AuthorizationRightsEnums.INCIDENTFILEEXPORTERVIDEO,
                ]) && (
                  <span
                    className={cx("pdfVideoIcon", { "active-extract": false })}
                    onClick={onExtractVideo}
                  >
                    {i18next.t("extraire la video")}
                  </span>
                )}
              </div>
            )}
            {!!Elem && !isLessThan30Days(Elem) && (
              <div className="no-extract-pdf-video">
                <span>{i18next.t("extraire le pdf")}</span>{" "}
                <span>{i18next.t("extraire la video")}</span>
              </div>
            )}
          </div>
        </StyledComponent.BoxSnapshotContainer>
      </div>
    </StyledComponent.ModalContainer>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  Elem?: any;
  arrayOfIncident?: any;
  onActive?: any;
  actionloading?: any;
  onExtractImpact?: any;
  onExtractVideo?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/modal/explore-incident/component.tsx